import { render, staticRenderFns } from "./PreDetail.vue?vue&type=template&id=6bd774ee&scoped=true&"
import script from "./PreDetail.vue?vue&type=script&lang=js&"
export * from "./PreDetail.vue?vue&type=script&lang=js&"
import style0 from "./PreDetail.vue?vue&type=style&index=0&id=6bd774ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd774ee",
  null
  
)

export default component.exports